<template>
  <loading-screen v-if="isLoading" />
</template>

<script>
import { setToken } from '@/utils/token';

export default {
  name: 'ChangeCard',

  data() {
    return {
      isLoading: true
    };
  },
  created() {
    const token = this.$route?.query?.t || '';
    setToken('tokenIvr', token);
    this.mpcCardUpdate();
  },
  methods: {
    mpcCardUpdate() {
      global.api.mpcCardUpdate({})
        .then((res) => {
          this.isLoading = false;
          window.location.href = res.data;
        })
        .catch(() => {
          this.isLoading = false;
          this.$router.push({
            name: 'Error',
            query: { error: 'GENERIC_ERROR' }
          });
        });
    }
  }
};
</script>
